module.exports = __webpack_public_path__ + "static/bootstrap-carousel-captions-a688d9d7838d77c320c914b4a47b43c2.png";